export default "__VITE_ASSET__BrsFUHVX__"